import { CarriersController } from "../../controllers/carriers-controller";
import { Carrier } from "../../models/carrier"
import { CarrierFilter } from "../../models/carrier-filter"
import { BusyService } from "../../services/busy-service";
import { WebApiService } from "../../services/web-api-service";
import { AureliaCookie } from 'aurelia-cookie';

import { observable, computedFrom, autoinject } from "aurelia-framework";
import { singleton } from 'aurelia-framework';
import { AppMessageService } from "../../services/app-message-service";
import { DialogService } from "aurelia-dialog";
import { UpdateUserDialog } from "../dialogs/update-user-dialog";
import { PageMessageService } from "../../services/page-message-service";
import { SimpleDialog } from "../dialogs/simple-dialog";
import { SecurityService } from "../../services/security-service";

@singleton()
@autoinject()
export class Requests {

    private readonly SYSTEM_USER_ID = "49605f7b-253e-46bf-978a-ee0a1c06faa1";

    public filter: "all" = "all";
    public includeInactive: false;

    public async setFilter(filter) {
        this.filter = filter;
        await this.loadDivisions();
        await this.loadRequests();
        this.filteredRequests = this.getFilteredRequests(this.filter);
    }

    assignedToMeCount = 0;
    availableForMeCount = 0;
    requests = [];
    filteredRequests: Array<any> = [];
    private allDivisions: Array<any> = [];

    private getFilteredRequests(filter: "all") {
        var filtered = this.requests;
        return filtered;
    }

    constructor(
        private securityService: SecurityService,
        private busyService: BusyService,
        private msg: PageMessageService,
        private dialogService: DialogService,
        private api: WebApiService) {
    }

    async activate(params) {
        AureliaCookie.set('nav_stack', 'requests', {});
        await this.initializePage();
    }

    async refresh() {
        this.initializePage();
    }

    async initializePage() {
        await this.setFilter(this.filter);
    }

    loadDivisions() {
        this.busyService.on();
        return this.api.get("Registration", "GetDivisions")
            .then((result) => {
                this.allDivisions = JSON.parse(result.response);
            })
            .finally(() => {
                this.busyService.off();
            });
    }


    async loadRequests() {
        this.busyService.on();
        try {
            var result;
            result = await this.api.get("Tasks", "GetAllRequests", { includeInactive: this.includeInactive });
            const requests = JSON.parse(result.response);
            requests.forEach(o => {
                /// per Rob R. - Display the name of the requesting division -   This should not really be part of the RequestDto
                if (o.openedBy.value != this.SYSTEM_USER_ID) {
                    if (o.variables_Divisions) {
                        const divisionCodes: any[] = [];
                        const divisionIds = JSON.parse(o.variables_Divisions);
                        divisionIds.forEach(divisionId => {
                            const divisionObj = this.allDivisions.find(ad => ad.id == divisionId);
                            if (divisionObj) {
                                divisionCodes.push(divisionObj.code);
                            }
                        });
                        o.divisionCodes = divisionCodes.toString();
                    }
                }
            });
            this.requests = requests;
        } finally {
            this.busyService.off();
        }
    }

}